__turbopack_context__.v({
  "featureCard": "ChargerFeaturesSection-module__qQ1IKW__featureCard",
  "featureDesc": "ChargerFeaturesSection-module__qQ1IKW__featureDesc",
  "featureIcon": "ChargerFeaturesSection-module__qQ1IKW__featureIcon",
  "featureTitle": "ChargerFeaturesSection-module__qQ1IKW__featureTitle",
  "featuresGrid": "ChargerFeaturesSection-module__qQ1IKW__featuresGrid",
  "section": "ChargerFeaturesSection-module__qQ1IKW__section",
});
